import React from "react";
import { SUPERNOVA_TOKENS } from "./supernovaContracts";

/**
 * The v4 hero: eyebrow, gradient wordmark, the one-line promise, and the
 * primary Stake CTA.
 *
 * THE EYEBROW STATES ONLY WHAT WE KNOW. The mockup reads "Arbitrum · 9,999
 * supply"; nothing in this app has read a total supply, and this tab's whole
 * rule is that it never renders a figure it hasn't got (see SupernovaTab.js).
 * So the second half is the collection's type count, which is a fact this repo
 * holds, in the same slot in the design.
 *
 * THE CTA SIGNS NOTHING. It opens the stake modal, which quotes the lock and
 * then hands off to the member's own wallet. With nothing stakeable it is
 * disabled and its title says why, rather than opening a modal that can only
 * refuse — the same contract as the slot rail's ghost cell.
 *
 * COMPLIANCE: "earns XP" is an in-app points balance and is disclaimed in the
 * mechanics panel and the footer. No return, yield, income, price or dollar
 * figure appears here, and none may be added.
 *
 * @param {Object} props
 * @param {(() => void)|null} props.onStake  opens the stake modal
 * @param {string} [props.stakeReason]       why staking isn't offered right now
 * @param {React.ReactNode} [props.children] the wallet line and header badge —
 *        state the mockup has no slot for, parked under the CTA
 */
const SupernovaHero = ({ onStake, stakeReason, children }) => (
  <div className="sn-hero" data-testid="supernova-hero">
    <div className="sn-eyebrow">
      Arbitrum One · {SUPERNOVA_TOKENS.length} Supernova types
    </div>
    {/* h2, not the mockup's h1: this is a tab inside the dashboard, and the
        page's h1 belongs to the app shell. Styled as the hero regardless. */}
    <h2 className="sn-h1">Supernova</h2>
    <p className="sn-tag">
      Four doors. Each one you stake lights a strategy slot and earns XP every
      day it stays locked.
    </p>
    <button
      type="button"
      className="sn-cta"
      onClick={onStake || undefined}
      disabled={!onStake}
      title={stakeReason || undefined}
    >
      Stake a Supernova
      {stakeReason && <span className="sr-only"> — {stakeReason}</span>}
    </button>
    {children && <div className="sn-hero-meta">{children}</div>}
  </div>
);

export default SupernovaHero;
